import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSuperadminAuth } from '../context/SuperadminAuthContext';
import LoadingScreen from './LoadingScreen';

// Un item de menu_keys ('/superadmin/companies') doit aussi couvrir ses
// sous-routes ('/superadmin/companies/new', '/superadmin/companies/42') —
// meme convention que le filtrage frontend du portail company, mais ici
// appliquee en vrai garde de route (pas juste un lien cache dans le nav).
const isPathAllowed = (pathname, menuKeys) =>
  menuKeys.some((key) => pathname === key || pathname.startsWith(`${key}/`));

const RequireSuperadminAuth = () => {
  const { admin, loading } = useSuperadminAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen />;
  if (!admin) return <Navigate to="/superadmin/login" replace />;

  // admin.menu_keys === null : superadmin illimite (is_superuser=True), aucune
  // restriction. Tableau : compte staff limite, cf. companies.models.AdminMenuPermission.
  if (Array.isArray(admin.menu_keys)) {
    if (admin.menu_keys.length === 0) {
      return (
        <div style={{ padding: 32, fontFamily: 'sans-serif' }}>
          <p>Aucun accès configuré sur ce compte. Contactez un superadmin.</p>
        </div>
      );
    }
    if (!isPathAllowed(location.pathname, admin.menu_keys)) {
      return <Navigate to={admin.menu_keys[0]} replace />;
    }
  }

  return <Outlet />;
};

export default RequireSuperadminAuth;
